// Libraries
import { ReactNode } from 'react';

// Hooks
import { useAppDispatch } from '../../../app/hooks';

// Features
import { clearModalContent } from '../../../features/app/appSlice';

// Components
import Button from '../../atoms/Button/Button';
import ModalContent from './ModalContent';

/**
 * @function ModalContentInAnotherSession
 * Describe the ModalContentInAnotherSession's function
 *
 * @example
 * return (
 *   <ModalContentInAnotherSession />
 * )
 */
function ModalContentInAnotherSession(): JSX.Element {
    const dispatch = useAppDispatch();

    function handleCloseClick() {
        dispatch(clearModalContent());
    }

    return (
        <ModalContent>
            <>
                <h2>
                    Already in a <b>session</b>
                </h2>
                <p>
                    You are in another session. You can only play in{' '}
                    <b>one session at a time</b>.
                </p>
                <Button
                    text="Back to Lobby"
                    style="primary"
                    onClick={() => handleCloseClick()}
                />
            </>
        </ModalContent>
    );
}

// Exports
export default ModalContentInAnotherSession;
